import { useState } from "react";
import { Code2, Copy, Check, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { ChatWidget } from "@/components/ChatWidget";

export default function EmbedScript({ activeBusiness, userId }) {
  const [copied, setCopied] = useState(false);

  if (!activeBusiness) {
    return (
      <div className="bg-[#FFFFFF] border border-dashed border-[#E2E8F0] rounded-2xl p-6 sm:p-12 text-center">
        <Code2 size={32} className="mx-auto text-slate-600 mb-3" />
        <p className="text-slate-600">Pilih atau buat bisnis terlebih dahulu untuk mendapatkan script embed.</p>
      </div>
    );
  }

  const origin = window.location.origin;
  const id = activeBusiness.id;
  const pos = activeBusiness.widget_position;
  const color = activeBusiness.brand_color;

  const snippet = `<!-- ContentChatAI Widget -->
<script>
(function(){
  var ID="${id}", POS="${pos}", COLOR="${color}", ORIGIN="${origin}";
  var side = POS==="bottom-left" ? "left:20px;" : "right:20px;";
  var btn=document.createElement("div");
  btn.innerHTML="&#128172;";
  btn.style.cssText="position:fixed;bottom:20px;"+side+"width:56px;height:56px;border-radius:50%;background:"+COLOR+";color:#fff;font-size:26px;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 8px 24px rgba(0,0,0,.3);z-index:999999;";
  var frame=document.createElement("iframe");
  frame.src=ORIGIN+"/widget/"+ID;
  frame.style.cssText="position:fixed;bottom:88px;"+side+"width:370px;max-width:calc(100vw - 32px);height:540px;max-height:calc(100vh - 120px);border:none;border-radius:16px;box-shadow:0 12px 40px rgba(0,0,0,.4);z-index:999999;display:none;";
  var open=false;
  btn.onclick=function(){open=!open;frame.style.display=open?"block":"none";btn.innerHTML=open?"&#10005;":"&#128172;";};
  document.body.appendChild(frame);document.body.appendChild(btn);
})();
</script>`;

  const copy = () => {
    navigator.clipboard.writeText(snippet);
    setCopied(true);
    toast.success("Script disalin ke clipboard");
    setTimeout(() => setCopied(false), 1800);
  };

  return (
    <div className="grid min-w-0 grid-cols-1 xl:grid-cols-5 gap-6">
      <div className="min-w-0 xl:col-span-3 space-y-5">
        <div className="bg-[#FFFFFF] border border-[#E2E8F0] rounded-2xl p-4 sm:p-6">
          <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
            <div className="flex items-center gap-2">
              <Code2 size={18} className="text-[#2563EB]" />
              <h2 className="font-heading font-bold">Script Embed — {activeBusiness.name}</h2>
            </div>
            <Button onClick={copy} data-testid="embed-code-copy-button" size="sm" className="bg-[#2563EB] hover:bg-[#1D4ED8] rounded-lg">
              {copied ? <Check size={14} className="mr-1" /> : <Copy size={14} className="mr-1" />}
              {copied ? "Tersalin" : "Copy"}
            </Button>
          </div>
          <p className="text-xs text-slate-500 mb-4">Tempelkan kode ini sebelum tag <span className="font-mono-code">&lt;/body&gt;</span> pada website Anda.</p>
          <pre className="bg-[#F8FAFC] border border-[#E2E8F0] rounded-xl p-4 text-xs font-mono-code text-slate-700 max-w-full overflow-x-auto whitespace-pre leading-relaxed" data-testid="embed-code-block">{snippet}</pre>
        </div>

        <div className="bg-[#FFFFFF] border border-[#E2E8F0] rounded-2xl p-4 sm:p-6">
          <h3 className="font-heading font-semibold text-sm mb-3">Konfigurasi aktif</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
            <div className="flex justify-between bg-[#F1F5F9] rounded-lg px-3 py-2"><span className="text-slate-500">Business ID</span><span className="font-mono-code text-xs truncate max-w-[120px]">{id}</span></div>
            <div className="flex justify-between bg-[#F1F5F9] rounded-lg px-3 py-2"><span className="text-slate-500">Posisi</span><span>{pos === "bottom-left" ? "Kiri Bawah" : "Kanan Bawah"}</span></div>
            <div className="flex justify-between bg-[#F1F5F9] rounded-lg px-3 py-2"><span className="text-slate-500">Warna</span><span className="flex items-center gap-1"><span className="w-3 h-3 rounded-full" style={{ background: color }} />{color}</span></div>
            <a href={`${origin}/widget/${id}`} target="_blank" rel="noreferrer" className="flex items-center justify-between bg-[#F1F5F9] rounded-lg px-3 py-2 text-[#2563EB] hover:bg-[#E2E8F0] transition-colors">
              <span>Buka widget</span><ExternalLink size={14} />
            </a>
          </div>
        </div>
      </div>

      <div className="min-w-0 xl:col-span-2">
        <div className="bg-[#FFFFFF] border border-[#E2E8F0] rounded-2xl p-4 sm:p-6 h-full">
          <h3 className="font-heading font-semibold text-sm mb-1">Live Preview</h3>
          <p className="text-xs text-slate-500 mb-4">Coba chatbot langsung di sini.</p>
          <div className="h-[min(540px,75dvh)]">
            <ChatWidget key={id} businessId={id} userId={userId} embedded />
          </div>
        </div>
      </div>
    </div>
  );
}
